module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_3column@2x-57675f4d924e285cd7dbbc0ad9b7e104.webp";